import TargetsUpload from "./TargetsUpload";

export default TargetsUpload;
